import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface BookingConceptProfile {
  title: string;
  description: string | null;
  price: number;
  durationMinutes: number;
}

export interface BookingConceptLocationAssignment {
  locationId: string;
  active: boolean;
}

export interface BookingConceptSyncStatus {
  factuProfile: { name: string; description: string | null; price: number };
  bookitProfile: BookingConceptProfile | null;
  locations: Array<{ locationId: string; name: string }>;
  assignments: BookingConceptLocationAssignment[];
}

@Injectable({ providedIn: 'root' })
export class BookingConceptService {
  constructor(private http: HttpClient) {}

  getSyncStatus(conceptUid: string): Observable<BookingConceptSyncStatus> {
    return this.http.get<BookingConceptSyncStatus>(
      `${environment.apiUrl}/api/v2/booking/concepts/${conceptUid}/sync-status`
    );
  }

  sync(
    conceptUid: string,
    data: {
      assignments: Array<{ locationId: string }>;
      title?: string;
      description?: string;
      price?: number;
      durationMinutes?: number;
      factuName?: string;
      factuDescription?: string;
      factuPrice?: number;
    }
  ): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/api/v2/booking/concepts/${conceptUid}/sync`,
      data
    );
  }
}
